import React from "react";
import { motion } from "framer-motion";
import { Briefcase, Users, GraduationCap, Building2, HeartHandshake, LineChart } from "lucide-react";
import { useSiteContent } from "@/context/SiteContentContext";

const ICONS = [GraduationCap, Users, LineChart, Building2, HeartHandshake, Briefcase];

export default function Services() {
  const content = useSiteContent();
  const s = content?.services;
  if (!s) return null;

  return (
    <section id="services" data-testid="services-section" className="py-24 lg:py-32 bg-sky-50/40">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-16 items-end">
          <div className="lg:col-span-7">
            <div className="flex items-center gap-3 mb-4">
              <span className="h-px w-12 bg-orange-600" />
              <span className="text-xs tracking-[0.25em] uppercase text-slate-500 font-display">
                {content?.sections?.services_label || "Services"}
              </span>
            </div>
            <h2 className="font-serif-sc text-4xl lg:text-5xl xl:text-6xl font-bold text-slate-900 leading-tight tracking-tight">
              {s.heading_top}<br />
              <span className="text-slate-500">{s.heading_bottom}</span>
            </h2>
          </div>
          <div className="lg:col-span-5">
            <p className="text-slate-600 leading-relaxed text-base">{s.description}</p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-slate-200">
          {s.items?.map((item, i) => {
            const Icon = ICONS[i % ICONS.length];
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.07 }}
                data-testid={`service-${i}`}
                className="bg-white p-8 lg:p-10 group cursor-default relative overflow-hidden"
              >
                <Icon size={28} strokeWidth={1.5} className="text-orange-600" />
                <div className="font-display text-[10px] tracking-[0.3em] uppercase text-slate-400 mt-6">
                  {item.en}
                </div>
                <h3 className="font-serif-sc text-2xl text-slate-900 mt-2">{item.title}</h3>
                <p className="text-sm text-slate-600 mt-4 leading-relaxed">{item.text}</p>
                <div className="absolute bottom-0 left-0 h-[2px] w-0 bg-orange-600 group-hover:w-full transition-all duration-500" />
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
